import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import './BusinessSearchForm.css'; // Import the standard CSS file

const BusinessSearchForm = () => {
  const [trade, setTrade] = useState('');
  const [postcode, setPostcode] = useState('');
  const navigate = useNavigate();

  const handleSearch = () => {
    // Redirect to registration with params
    navigate(`/register/business?trade=${encodeURIComponent(trade)}&postcode=${encodeURIComponent(postcode)}`);
  };

  const handleKeyPress = (e) => {
    if (e.key === 'Enter') {
      handleSearch();
    }
  };

  return (
    <div className="bs-cta-pill-wrapper">
      <div className="bs-search-pill-container">
        
        {/* Trade Input */}
        <input 
          type="text" 
          placeholder="What's your primary trade?" 
          className="bs-search-input-pill left"
          value={trade}
          onChange={(e) => setTrade(e.target.value)}
          onKeyDown={handleKeyPress}
        />
        
        <div className="bs-pill-divider"></div>
        
        {/* Postcode Input */}
        <input 
          type="text" 
          placeholder="Postcode" 
          className="bs-search-input-pill right"
          value={postcode}
          onChange={(e) => setPostcode(e.target.value)}
          onKeyDown={handleKeyPress}
        />
        
        {/* Search Button */}
        <button onClick={handleSearch} className="bs-search-btn-pill">
           Start Winning Work
        </button>
      </div>
    </div>
  );
};

export default BusinessSearchForm;